import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  pageLink: string[] = []

  constructor(
    private localStorage: LocalStorageService,
    private router: Router
  ) { }
  private isAuthenticated = false;

  userPermission(pages) {
    this.pageLink = this.extractPageLinks(pages);
    const pageLinkJSON = JSON.stringify(this.pageLink);
    this.localStorage.setLocalStorage({ key: "pageLinks", value: pageLinkJSON });
  }
  extractPageLinks(data): string[] {
    const pageLinks: string[] = [];
    if (data) {
      for (const menu of data) {
        for (const i of menu.Menus) {
          for (const subMenu of i.subMenus) {
            this.extractPageLinksRecursive(subMenu, pageLinks);
          }
        }
      }
    }

    return pageLinks;
  }

  extractPageLinksRecursive(menu, pageLinks: string[]) {
    if (menu.PageLink && menu.PageLink !== "#") {
      let cleanedLink = menu.PageLink.trim();
  
      cleanedLink = '/' + cleanedLink.replace(/^\/+/, '');
  
      pageLinks.push(cleanedLink);
    }
  
    if (menu.subMenus && menu.subMenus.length > 0) {
      for (const subMenu of menu.subMenus) {
        this.extractPageLinksRecursive(subMenu, pageLinks);
      }
    }
  }
  

  hasPermission(permission: string): boolean {
    const pages: string[] = JSON.parse(this.localStorage.getLocalStorage({ key: 'pageLinks' })) || [];
  
    const parts = permission.split('/');
    const lastPart = parts[parts.length - 1];
    const isNumeric = /^\d+$/.test(lastPart);
    
    // Clean the URL to match stored pageLinks
    let cleanedUrl = isNumeric ? parts.slice(0, -1).join('/') : permission;
    cleanedUrl = '/' + cleanedUrl.replace(/^\/+/, '').trim();
  
    console.log('Cleaned URL:', cleanedUrl);
    console.log('Pages:', pages);
  
    return pages.includes(cleanedUrl);
  }
  

  // Check if the user is authenticated
  isAuthenticatedUser() {
    const token = this.localStorage.getLocalStorage({key:'token'});
    this.isAuthenticated = token ? true : false;
    return this.isAuthenticated;
  }

  // Logout user
  logout() {
    // Clear encrypted localStorage items
    this.localStorage.removeLocalStorage({ key: 'token' });
    this.localStorage.removeLocalStorage({ key: 'Role' });
    this.localStorage.removeLocalStorage({ key: 'RoleCode' });
    this.localStorage.removeLocalStorage({ key: 'UserEmailId' });
    this.localStorage.removeLocalStorage({ key: 'UserID' });
    this.localStorage.removeLocalStorage({ key: 'UserName' });
    this.localStorage.removeLocalStorage({ key: 'ModuleWisePage' });
    this.localStorage.removeLocalStorage({ key: 'user_data' });
    this.localStorage.removeLocalStorage({ key: 'pageLinks' });
    
    // Clear regular localStorage
    localStorage.clear();
    
    // Clear cookies
    this.localStorage.deleteAllCookie();
    
    this.isAuthenticated = false;
    this.router.navigate(['/login']);
  }
}
